export default __webpack_public_path__ + "static/bi-stack-7806d114fbf0b2c987254de48c70f29b.svg";